/**
 * Regeln der Beteiligten-Liste (M-002 F7, Variante P4): eine Person je Zeile mit einer Rolle am Objekt.
 * Reine Funktionen ohne React, damit die Regel „genau eine Person trägt die Hauptrolle“ testbar bleibt.
 */
export interface Beteiligung {
  personId: string;
  rolle: string;
}

export interface BeteiligteRegel {
  /** Rolle, die höchstens eine Person tragen darf (Aufgaben: „verantwortlich“). */
  genauEine?: string;
  /** Rolle, auf die die bisherige Person zurückfällt (Aufgaben: „beteiligt“). */
  herabstufenAuf?: string;
}

export interface BeteiligteAenderung {
  liste: Beteiligung[];
  /** Person, die auf `herabstufenAuf` gesetzt wurde, weil eine andere die Hauptrolle übernahm. */
  herabgestuft: Beteiligung | null;
}

/** Setzt die Rolle einer Person (fügt sie bei Bedarf hinzu). Die zweite Wahl der Hauptrolle stuft die erste herab. */
export function setzeRolle(liste: Beteiligung[], personId: string, rolle: string, regel: BeteiligteRegel = {}): BeteiligteAenderung {
  const vorhanden = liste.some((b) => b.personId === personId);
  let neu = vorhanden ? liste.map((b) => (b.personId === personId ? { ...b, rolle } : b)) : [...liste, { personId, rolle }];
  let herabgestuft: Beteiligung | null = null;
  if (regel.genauEine && regel.herabstufenAuf && rolle === regel.genauEine) {
    const ersatz = regel.herabstufenAuf;
    neu = neu.map((b) => {
      if (b.personId !== personId && b.rolle === regel.genauEine) {
        herabgestuft = { ...b, rolle: ersatz };
        return herabgestuft;
      }
      return b;
    });
  }
  return { liste: neu, herabgestuft };
}

export function entferne(liste: Beteiligung[], personId: string): Beteiligung[] {
  return liste.filter((b) => b.personId !== personId);
}
